<template>
    <div class="edit-user-info">
        <Loading v-if="!loadingDone"/>
        <ul class="user-info-item" v-if="loadingDone">
            <li style="margin-bottom:4px;border-bottom:none;"><span class="item-key">头像</span><van-uploader :before-read="beforeRead" :after-read="afterRead"/><span class="avatar-item"><img :src="userAvatar" alt=""></span><van-icon name="arrow"/></li>
            <li><router-link :to="{name:'penname',params:{name:userInfo.name}}"><span class="item-key">笔名</span><span class="item-value">{{userInfo&&userInfo.name?userInfo.name:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
            <li class="no-edit"><span class="item-key">真实姓名</span><span class="item-value">{{userInfo&&userInfo.real_name?userInfo.real_name:'待完善'}}</span></li>
            <li @click="showSexSel"><span class="item-key">性别</span><span class="item-value" v-text="sex"></span><van-icon name="arrow"/></li>
            <van-action-sheet
                v-model="sexSelShow"
                :actions="sexSelItem"
                cancel-text="取消"
                @cancel="cancelSexSel"
                @select="onSexSel"
            />
            <li @click="showTimePicker"><span class="item-key">出生日期</span><span class="item-value" v-text="birthDate"></span><van-icon name="arrow"/></li>
            <van-popup
                v-model="timePickerShow"
                position="bottom"
                round
                :style="{ height: '30%' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    item-height="40"
                    @confirm="getBirthDate"
                    @cancel="closeBirthDate"
                    :min-date="minDate"
                />
            </van-popup>
            <li class="no-edit"><span class="item-key">手机号</span><span class="item-value">{{userInfo&&userInfo.phone?userInfo.phone:'待完善'}}</span></li>
            <li @click="showEduInfo"><span class="item-key">最高学历</span><span class="item-value" v-text="eduInfo"></span><van-icon name="arrow"/></li>
            <van-action-sheet
                v-model="eduInfoShow"
                :actions="eduInfoItem"
                cancel-text="取消"
                @cancel="cancelEduInfo"
                @select="onEduInfoSel"
            />
            <li @click="showLocationSel"><span class="item-key">所在地区</span><span class="item-value" v-text="locationDetail"></span><van-icon name="arrow"/></li>
            <van-popup
                v-model="locationShow"
                position="bottom"
                round
                :style="{ height: '40%' }"
            >
                <van-area 
                    :area-list="areaList" 
                    @confirm="getLocation"
                    @cancel="closeLocationSel"
                    :value="locationValue"
                />
            </van-popup>
            <li><router-link :to="{name:'email',params:{email:userInfo.email}}"><span class="item-key">邮箱</span><span class="item-value">{{userInfo&&userInfo.email?userInfo.email:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
            <li><router-link :to="{name:'selfintro'}"><span class="item-key">自我介绍</span><span class="item-value value-break-line">{{userInfo&&userInfo.intro?userInfo.intro:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
            <li><router-link :to="{name:'works'}"><span class="item-key">代表作品</span><span class="item-value value-break-line">{{userInfo&&userInfo.works?userInfo.works:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
            <li><router-link :to="{name:'goodat'}"><span class="item-key">擅长题材</span><span class="item-value value-break-line">{{userInfo&&userInfo.adept?userInfo.adept:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
            <li><router-link :to="{name:'prize'}"><span class="item-key">作品及获奖介绍</span><span class="item-value value-break-line">{{userInfo&&userInfo.prize?userInfo.prize:'待完善'}}</span><van-icon name="arrow"/></router-link></li>
        </ul>
    </div>
</template>

<script>
import {timeStr} from '@/assets/api/GmtToStr.js'
import areaList from '@/assets/api/areaList.js'
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'EditUserInfo',
    data(){
        return{
            userInfo:'',

            loadingDone:false,

            icon:new FormData(),

            userAvatar:'',

            timePickerShow:false,
            currentDate: new Date(),
            minDate: new Date(1900, 1, 1),
            birthDate:"待完善",
            
            areaList:areaList,
            locationShow:false,
			locationDetail:'待完善',
			locationValue:'',

            sex:'待完善',
            sexSelShow:false,
            sexSelItem:[{name:'男',value:0},{name:'女',value:1}],

            eduInfo:'待完善',
            eduInfoShow:false,
            eduInfoItem:[{name:'小学'},{name:'初中'},{name:'高中'},{name:'大专'},{name:'本科'},{name:'硕士'},{name:'博士'},{name:'博士后'}]
        }
    },
    created(){
		let date='1913-03-18'
        Axios.get('/user/info').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.userInfo=response.data.data
                    this.userInfo.province?this.locationDetail=this.userInfo.province.name+this.userInfo.city.name+this.userInfo.district.name:this.locationDetail="待完善"
                    this.userInfo.education?this.eduInfo=this.userInfo.education:this.eduInfo="待完善"
                    this.userInfo.birthday?this.birthDate=this.userInfo.birthday:this.birthDate="待完善"
					this.userInfo.sex.name?this.sex=this.userInfo.sex.name:this.sex="待完善"
					this.userInfo.district?this.locationValue=this.userInfo.district.value:this.locationValue=""
					this.userInfo.birthday?this.currentDate=new Date(this.userInfo.birthday.replace(/-/,"/")):this.currentDate=new Date()
                    this.userAvatar=this.userInfo.icon
					this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }
        )
    },
    methods:{
        //头像上传格式校验
        beforeRead(file) {
            if (file.type=='image/jpeg'||file.type=='image/png'||file.type=='image/jpg'||file.type=='image/gif'){
                return true
			}else{
				this.$swal({
					text:'请选择图片文件',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
                return false
			}
        },
        //上传头像
        afterRead(file) {
        // 此时可以自行将文件上传至服务器
          this.icon.append('icon',file.file)
          Axios.post('/user/update',this.icon)
          .then(
              response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.userAvatar=file.content
                }
              }
          ).catch(
              error=>{
					this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
              }
          )
       },
        //展开生日时间选择器
        showTimePicker(){
            this.timePickerShow=true
        },
        //为生日选项框赋值
        getBirthDate(val){
            this.birthDate=timeStr(val)
            this.updateUserInfo('birthday',this.birthDate)
            this.timePickerShow=false
        },
        //关闭生日时间选择框
        closeBirthDate(){
            this.timePickerShow=false
        },
        //展开所在地选项选择项
        showLocationSel(){
            this.locationShow=true
        },
        //为所在地选项赋值
        getLocation(val){
			this.locationDetail=val[0].name + val[1].name + val[2].name
            Axios.post('/user/update',{province:val[0].code,city:val[1].code,district:val[2].code}).catch(
                error=>{
                    console.log(error)
                }
            )
            this.locationShow=false
        },
        //关闭所在地选项项
        closeLocationSel(){
            this.locationShow=false
        },
        //显示性别选择项
        showSexSel(){
            this.sexSelShow=true
        },
        //为性别信息赋值
        onSexSel(item){
            this.sex=item.name
            this.updateUserInfo('sex',item.value)
            this.sexSelShow=false
        },
        //关闭性别选择框
        cancelSexSel(){
            this.sexSelShow=false
        },
        //显示学历选择信息
        showEduInfo(){
            this.eduInfoShow=true
        },
        //为学历信息赋值
        onEduInfoSel(item){
            this.eduInfo=item.name
            this.updateUserInfo('education',item.name)
            this.eduInfoShow=false
        },
        //关闭学习选择项
        cancelEduInfo(){
            this.eduInfoShow=false
        },
        //调用接口更新用户信息
        updateUserInfo(infokey,infoValue){
            let updateInfo={}
            updateInfo[infokey]=infoValue
            Axios.post('/user/update',updateInfo)
		}
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
    //出生日期地区选择字体
    /deep/.van-picker-column__item{
        font-size:26px !important;
    }
    //出生日期地区选择框title栏高度
    /deep/.van-picker__toolbar{
        height:80px !important;
        line-height:80px !important;
        padding:0 16px !important;
    }
    //出生日选择框确认取消按钮字体及颜色
    /deep/.van-picker__confirm,/deep/.van-picker__cancel{
        color:#bf0000 !important;
        font-size:24px;
    }
    //最高学历 性别 选择框字体大小及高度
    /deep/.van-action-sheet__item{
        height:80px;
        padding:20px 0;
    }
    /deep/.van-action-sheet__name{
        font-size:26px !important;
    }
    //最高学历 性别 选择框取消按钮字体大小及高度
    /deep/.van-action-sheet__cancel{
        font-size:26px !important;
        height:80px !important;
        line-height:80px !important;
    }
    .edit-user-info{
        padding-top:88px;
        background:#F8F6F7;
        width:750px;
        .user-info-item{
            .no-edit{
                color:#999 !important;
            }
            li{
                a{
                    color:#222;
                }
                padding:36px 44px;
                color:#222;
                overflow:hidden;
                border-bottom:1px solid #F8F6F7;
                background:#fff;
                position:relative;
                .van-icon-arrow{
                    position:absolute;
                    right:12px;
                    top:50%;
                    height:28px;
                    width:28px;
                    font-size:28px;
                    margin-top:-14px;
                    color:#282828;
                }
                .item-key{
                    font-size:26px;
                    font-weight:bold;
                    position:absolute;
                    top:50%;
                    left:44px;
                    height:26px;
                    transform:translateY(-20px);
                }
                .avatar-item{
                    display:inline-block;
                    width:60px;
                    height:60px;
                    float:right;
                    img{
                        width:100%;
                        height:100%;
                        border-radius:50%;
                    }
                }
                .item-value{
                    font-size:26px;
                    float:right;
                }
                .value-break-line{
                    width:460px;
                    word-break:break-all;
                    line-height:30px;
                }
            }
            li:first-child{
                height:60px;
                padding:20px 44px;
                .avatar-item{
                    position:absolute;
                    right:44px;
                }
                /deep/.van-uploader{
                    width:100%;
                    border-radius:50%;
                    position:absolute;
                    right:44px;
                    z-index:99;
                    opacity:0;
                    .van-uploader__wrapper{
                        width:100%;
                    }
                    .van-uploader__upload{
                        width:100% !important;
                    }
                }
            }
            li:last-child{
                border-bottom:none;
            }
        }
    }
</style>